import { configureStore, ThunkAction, Action } from "@reduxjs/toolkit";
import organizationReducer from "@store/organizationSlice";
import accountReducer from "@store/userAccountSlice";
import userInfoReducer from "@store/userInfoSlice";
import assessmentFormReducer from "@store/assessmentFormSlice";
import assessmentFlowReducer from "@store/assessmentFlowSlice";
import assessmentReducer from "@store/assessmentSlice";
import globalSettingsReducer from "@store/globalSettingsSlice";
import appAccessReducer from "@store/appAccessSlice";
import locationsReducer from "@store/locationsSlice";
import userDetailReducer from "@store/userDetailSlice";
import agreementReducer from "../features/signup/store/agreementSlice";
import newExamineeReducer from "@fadmin/tabs/assessments/store/newExamineeSlice";
import startAssessmentReducer from "@fadmin/tabs/assessments/store/startAssessmentSlice";
import assessmentContextReducer from "@fadmin/tabs/assessments/store/assessmentContextSlice";
import assessmentResultReducer from "@store/assessmentResultSlice";
import internetConnectionReducer from "@store/internetConnectionSlice";
import organizationAssessmentsReducer from "@store/organizationAssessmentsSlice";

export const store = configureStore({
    reducer: {
        account: accountReducer,
        user: userInfoReducer,
        organization: organizationReducer,
        agreement: agreementReducer,
        assessment: assessmentReducer,
        assessmentForm: assessmentFormReducer,
        globalSettings: globalSettingsReducer,
        assessmentFlow: assessmentFlowReducer,
        appAccess: appAccessReducer,
        newExaminee: newExamineeReducer,
        orgLocations: locationsReducer,
        startAssessment: startAssessmentReducer,
        assessmentContext: assessmentContextReducer,
        userDetail: userDetailReducer,
        assessmentResult: assessmentResultReducer,
        internetConnection: internetConnectionReducer,
        organizationAssessments: organizationAssessmentsReducer
    }
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>;
